


















import Vue from 'vue';
import {Actions} from '@/store';

export default Vue.extend({
  name: 'SignOutView',
  created() {
    this.$store
      .dispatch(Actions.account.signOut)
      .then(() => {
        this.$router.replace({name: 'account-sign-in'});
      });
  },
});
